import React from 'react';
import PropTypes from 'prop-types';
import { FLAGS_NONREMOVABLE } from 'utils/constants';
import { ERROR_TEXT_NO_DEFAULT_VALUE } from 'langs/en/errors';
import InputContainer from 'components/InputContainer';
import TypesContainer from 'components/Fields/TypesContainer';
import TextAttribute from 'components/Fields/TextAttribute';

class FieldText extends React.Component {

  validateAndChangeDefaultValue = (keyPath, value) => {
    this.props.onFieldValueChange(keyPath, value);

    if (this.props.values.hidden && value.length === 0) {
      this.props.fieldValidityChanged(keyPath, false, ERROR_TEXT_NO_DEFAULT_VALUE);
    } else {
      this.props.fieldValidityChanged(keyPath, true);
    }
  }

  render() {
    const standardFieldNameIsNull = !this.props.values.name;
    const requiredStandardField = this.props.values.flags && this.props.values.flags.includes(FLAGS_NONREMOVABLE);
    return (
      <div className="col mt-2">
        <div className="row mb-4">
          <div className="col-sm-6">
            <TypesContainer
              disabled={requiredStandardField || standardFieldNameIsNull}
              radioGroupName="Field Type"
              keyPath={this.props.keyPath}
              onFieldValueChange={this.props.onFieldValueChange}
              values={this.props.values}
              uiState={this.props.uiState.type}
            />
          </div>
          <div className="col-sm-6">
            <InputContainer
              label="Default Value"
              keyPath={[...this.props.keyPath, 'value']}
              uiState={this.props.uiState.editors.value}
              disabled={requiredStandardField || standardFieldNameIsNull}
            >
              <TextAttribute
                keyPath={[...this.props.keyPath, 'value']}
                value={this.props.values.editors.value}
                disabled={requiredStandardField || standardFieldNameIsNull}
                onFieldValueChange={this.validateAndChangeDefaultValue}
                onFieldUIStateChange={this.props.onFieldUIStateChange}
              />
            </InputContainer>
          </div>
        </div>
      </div>
    );
  }
}

FieldText.propTypes = {
  fieldValidityChanged: PropTypes.func.isRequired,
  values: PropTypes.shape({
    editors: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }).isRequired,
    flags: PropTypes.array.isRequired,
    hidden: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  uiState: PropTypes.object.isRequired,
  keyPath: PropTypes.array.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
};

function FieldConfigureText(props) {
  return <FieldText {...props} />;
}

export default FieldConfigureText;
